import { Quote } from "lucide-react";
import { Section, SectionHeading } from "@/components/common/Section";
import {
  Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious,
} from "@/components/ui/carousel";
import { testimonials } from "@/data/content";

export function Testimonials() {
  return (
    <Section id="testimonials" bg="white">
      <SectionHeading
        eyebrow="Client Voices"
        title="What our clients say"
        subtitle="Trusted by corporates, retailers and institutions across Bengaluru & Karnataka."
        align="center"
      />
      <div className="mt-14 relative px-2 md:px-12" data-testid="testimonials-carousel">
        <Carousel opts={{ align: "start", loop: true }}>
          <CarouselContent className="-ml-4">
            {testimonials.map((t, i) => (
              <CarouselItem key={i} className="pl-4 md:basis-1/2">
                <div className="h-full bg-mist border border-black/5 p-8 flex flex-col" data-testid={`testimonial-${i}`}>
                  <Quote className="h-8 w-8 text-gold" />
                  <p className="mt-5 text-base md:text-lg leading-relaxed text-charcoal flex-1">
                    “{t.quote}”
                  </p>
                  <div className="mt-6 pt-5 border-t border-black/10">
                    <div className="font-heading text-lg text-navy">{t.name}</div>
                    <div className="text-sm text-charcoal/60">{t.role}</div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-2" data-testid="testimonial-prev" />
          <CarouselNext className="hidden md:flex -right-2" data-testid="testimonial-next" />
        </Carousel>
      </div>
    </Section>
  );
}
